import React from "react";
import {
  defineBlock,
  smartProps,
  EditableDiv,
  EditableImg,
  useEditor,
} from "@smartfire/gutenberg-react";
import style from "./block.module.scss";
import { ReactComponent as Arrow } from "../assets/arrow_right.svg";

function Block({ title, description, buttonText, buttonUrl, icon, theme }) {
  const { isEditing } = useEditor();

  return (
    <div className={style.block}>
      {isEditing ? (
        <>
          <div className={style.iconContainer}>
            <EditableImg smartProp="icon" className={style.icon} />
          </div>
          <EditableDiv
            className={style.title}
            smartProp="title"
            placeholder={"Entrez un titre"}
          />
          <EditableDiv
            className={style.text}
            smartProp="description"
            placeholder={"Entrez une description"}
          />
          <EditableDiv
            className={style.text}
            smartProp="buttonText"
            placeholder={"Entrez un texte de bouton"}
          />
          <EditableDiv
            className={style.text}
            smartProp="buttonUrl"
            placeholder={"Entrez une url"}
          />
        </>
      ) : (
        <>
          {title !== "" && (
            <>
              <div className={style.iconContainer}>
                <EditableImg smartProp="icon" className={style.icon} />
              </div>
              <div
                className={style.title}
                dangerouslySetInnerHTML={{ __html: title }}
              />
              <div
                className={style.description}
                dangerouslySetInnerHTML={{ __html: description }}
              />
            </>
          )}
          {buttonText !== "" && buttonUrl !== "" && (
            <a className={style.linkContainer} href={buttonUrl}>
              <div className={style.iconContainer}>
                <EditableImg smartProp="icon" className={style.icon} />
              </div>
              <div className={style.link}>
                <span dangerouslySetInnerHTML={{ __html: buttonText }} />{" "}
                <Arrow />
              </div>
            </a>
          )}
          {buttonText !== "" && buttonUrl === "" && (
            <div className={style.linkContainer}>
              <div className={style.iconContainer}>
                <EditableImg smartProp="icon" className={style.icon} />
              </div>
              <div className={style.link}>
                <span dangerouslySetInnerHTML={{ __html: buttonText }} />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    title: smartProps.string.withDefault(""),
    description: smartProps.string.withDefault(""),
    buttonText: smartProps.any.withDefault(""),
    buttonUrl: smartProps.any.withDefault(""),
    icon: smartProps.any.withDefault(""),
  },
  setup: {
    title: "Encart",
    parents: ["smartfire/encarts-grid"],
  },
});
